const paymentInfo = {
  subtitle: 'Мы работаем над проектом небольшими итерациями. Это удобно для вас и&nbsp;безопасно для проекта.',
  items: [
  'Оцениваем задачи спринта в&nbsp;часах',
  'Рассчитываем приблизительную стоимость работ за&nbsp;спринт',
  'Берем 100% предоплаты от&nbsp;полученной суммы за&nbsp;один отдельно взятый спринт',
  ],
  footnote: [
    'Не берем предоплату от&nbsp;бюджета за&nbsp;весь проект.',
    'Мы работаем только по&nbsp;двухнедельным спринтам и&nbsp;берем предоплату 100% от&nbsp;суммы одного отдельно взятого спринта (примерно 1/15 - 1/20 стоимости всего проекта).'
  ],
}

/* Данные для страниц услуг */

export const serviceMenuItems = [
  {
    menuTitle: 'Веб-разработка',
    title: 'Веб-разработка',
    url: 'veb-razrabotka',
    icon: 'frame.svg',
    imgSrc: 'veb-razrabotka',
    text: 'Разрабатываем сложные сервисы: агрегаторы, маркетплейсы, информационные порталы, биржи. Больше всего у&nbsp;нас выполненных проектов в&nbsp;сферах: недвижимость, SMM, e-commermce, парсеры, 3D моделирование и&nbsp;автоматизация по&nbsp;работе с&nbsp;рендер-фермами, аналитика.',
    serviceBlocks: [
      {
        key: 'task',
        title: 'задачи, которые мы решаем',
        text: [
        'Поиск специалистов',
        'Создание масштабного IT-продукта: биржи, агрегаторы, маркет-плейсы, информационные порталы, системы мониторинга',
        'Техническая консультация',
        'Аудит проекта',
        ]
      },
      {
        key: 'process',
        title: 'Процесс работы',
        items: [
          {subtitle: 'Аудит', text: 'Перед тем, как что-то рекомендовать, мы&nbsp;тщательно изучаем проект. Его слабые и&nbsp;сильные стороны, чтобы предложенный нами план опирался исключительно на&nbsp;факты и&nbsp;на&nbsp;потребности бизнеса клиента.',},
          {subtitle: 'Изучение проблем клиента ', text: 'Тщательное изучение узких мест сайта клиента и тех бизнес процессов, которые выстроены вокруг сайта.',},
          {subtitle: 'Составление плана развития проекта в целом', text: 'В&nbsp;отличие от&nbsp;классических веб-студий мы&nbsp;не&nbsp;ограничиваемся рекомендациями только по&nbsp;сайту клиента, а&nbsp;предлагаем комплексный план по&nbsp;устранению проблем в&nbsp;тех сферах бизнеса, которые напрямую взаимодействуют с&nbsp;сайтом.',},
          {subtitle: 'Разработка пользовательского интерфейса', text: 'От&nbsp;того насколько интерфейс удобен, зависит лояльность пользователя и&nbsp;его конверсия в&nbsp;клиенты. Мы&nbsp;не&nbsp;побоимся поставить знак равенства между конверсией сайта и&nbsp;доходностью бизнеса. Современные версии поисковых роботов Яндекс и&nbsp;Google тщательно отслеживают поведенческие факторы: то&nbsp;насколько сайт удобен для пользователей и&nbsp;покупателей, поэтому без грамотного проектирования юзабилити сайта невозможно SEO продвижение.',},
          {subtitle: 'Разработка сайта', text: 'Командой программистов верстается сайт и&nbsp;пишется технический функционал проекта с&nbsp;нуля или на&nbsp;основе движков. Мы&nbsp;работаем со&nbsp;следующими движками, фреймворками: Django, Bootstrap, Backbone и&nbsp;т.&nbsp;д.',},
          {subtitle: 'Коммерческий запуск проекта', text: 'Подавляющая часть наших клиентов, получая готовый проект и&nbsp;решенные задачи в&nbsp;своем бизнесе, остаются с&nbsp;нами навсегда. Также они доверяют нам свою рекламу в&nbsp;интернете.',},
        ]
      },
      {
        key: 'feature',
        title: 'Особенности работы',
        items: [
          { subtitle: 'Работаем по методологии Scrum', text: 'Разработка ведется двухнедельными итерациями (спринтами). Один спринт равен 2 неделям. В&nbsp;начале каждого спринта мы&nbsp;обсуждаем с&nbsp;вами пул задач, обязательных к&nbsp;выполнению в&nbsp;спринте.'},
          { subtitle: 'Гибкая система', text: 'Scrum позволяет без ущерба для темпа разработки оперативно добавлять новые задачи, которые неизбежно появятся в&nbsp;процессе работы над проектом. Новые задачи мы&nbsp;берем в&nbsp;следующий спринт. Каждые две недели вы&nbsp;видите значимые для проекта результаты.'},
          { subtitle: 'Открытое ведение проекта', text: 'Все задачи фиксируем в&nbsp;системе управления проектами Trello. В&nbsp;ней вы&nbsp;наглядно видите прогресс всей разработки, выполненные задачи, трудности и&nbsp;их&nbsp;решение, можете не&nbsp;только смотреть, но&nbsp;и&nbsp;комментировать. Сохраняется вся история действий. При такой системе вы&nbsp;не&nbsp;будете спрашивать &laquo;А&nbsp;что сделано? За&nbsp;что мы&nbsp;платим?&raquo;.'},
        ]
      },
      {
        key: 'payment',
        title: 'Система оплаты',
        paymentInfo,
      },
      // {
      //   key: 'portfolio',
      //   title: 'Портфолио',
      //   items: [
      //     {
      //       href: '#',
      //       src: 'services/jata_ru.jpg',
      //       type: 'биржа',
      //       title: 'Jata | Биржа рекламы на автомобилях',
      //       description: 'На легковых машинах, грузовых и даже на городских автобусах и "маршрутках".',
      //     },
      //     {
      //       href: '#',
      //       src: 'services/alfacvet.jpg',
      //       type: 'маркетплейс',
      //       title: 'Альфацвет | магазин искусственных цветов',
      //       description: 'Мощный магазин с разветвленной структурой каталога и широким ассортиментом.',
      //     },
      //     {
      //       href: '#',
      //       src: 'services/placeholder.jpg',
      //       type: 'сервис',
      //       title: 'Oncona | мониторинг онкобольных онлайн',
      //       description: 'Оптимизация работы медиков и упрощение медицинского документооборота.',
      //     },
      //   ],
      // },
      // {
      //   key: 'faq',
      //   title: 'часто задаваемые вопросы',
      //   items: [
      //     {
      //       id: 'q0',
      //       question: 'Подписываем ли NDA?',
      //       response: 'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Omnis animi necessitatibus nemo nobis earum esse libero laudantium. Exercitationem, labore pariatur?',
      //     },
      //     {
      //       id: 'q1',
      //       question: 'Какие гарантии?',
      //       response: 'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Omnis animi necessitatibus nemo nobis earum esse libero laudantium. Exercitationem, labore pariatur?',
      //     },
      //     {
      //       id: 'q2',
      //       question: 'А что будет, если позже всплывут ваши ошибки?',
      //       response: 'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Reiciendis numquam repellendus, et sapiente at neque asperiores mollitia dolorum dicta perferendis temporibus impedit ut quibusdam illum maiores aliquid minus molestias assumenda incidunt voluptate est fugit cum. Consequatur voluptates nisi inventore ab fugiat debitis, nostrum, quod quia deserunt accusantium libero. Nostrum, inventore!',
      //     },
      //     {
      //       id: 'q3',
      //       question: 'Где находимся?',
      //       response: 'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Reiciendis numquam repellendus, et sapiente at neque asperiores mollitia dolorum dicta perferendis temporibus impedit ut quibusdam.',
      //     },
      //     {
      //       id: 'q4',
      //       question: 'Сколько нам надо времени, чтобы дать оценку по вилке сроки-деньги?',
      //       response: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Recusandae, accusamus.',
      //     },
      //     {
      //       id: 'q5',
      //       question: 'Готовы работать за долю от будущей прибыли?',
      //       response: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Recusandae, accusamus.',
      //     },
      //   ]
      // },
    ]
  },
  {
    menuTitle: 'Маркетинг для b2b',
    title: 'Маркетинг для b2b',
    url: 'marketing',
    icon: 'marketing.svg',
    imgSrc: 'marketing',
    text: 'Комплексный подход к&nbsp;продвижению ВАШЕГО БИЗНЕСА &laquo;под ключ&raquo;: от&nbsp;анализа ниши, целевой аудитории и&nbsp;медиапланирования до&nbsp;полного ведения социальных сетей (контент, трафик, дизайн). Постоянная аналитика на&nbsp;каждом этапе, контроль выгорания сегментов, коррекция гипотез, поиск новых идей.',
    serviceBlocks: [
      {
        key: 'task',
        title: 'задачи, которые мы решаем',
        text: [
        'Изучение целевой аудитории клиента',
        'Привлечение аудитории на&nbsp;сайт с&nbsp;целью совершения конверсионного действия',
        'Проработка маркетинговой стратегии от&nbsp;показа рекламы до&nbsp;продажи',
        'Медиапланирование',
        'Аналитика рекламных кампаний и&nbsp;составление отчетов',
        'Автоматизация продаж&nbsp;&mdash; рассылки, скрипты, чат-боты',
        'Составление контент-стратегии, контент-планов и&nbsp;работа на&nbsp;бренд. Ведение аккаунта в&nbsp;соц.сетях',
        'Оформление соц.сетей, разработка продающего дизайна',
        'Консультирование по&nbsp;существующим рекламных кампаниям (если они есть) и&nbsp;помощь в&nbsp;их&nbsp;оптимизации',
        ]
      },
      {
        key: 'process',
        title: 'Процесс работы',
        items: [
          {subtitle: 'Брифинг', text: 'Заполняется бриф, мы&nbsp;его изучаем и&nbsp;уточняем нужные детали.',},
          {subtitle: 'Консультация', text: 'Мы&nbsp;проговариваем особенности продвижения и&nbsp;стратегию. Рассказываем о&nbsp;том, как строится работа с&nbsp;нами.',},
          {subtitle: 'Оффер', text: 'Составляем коммерческое предложение.',},
          {subtitle: 'Стратегия и&nbsp;планирование', text: 'В&nbsp;зависимости от&nbsp;типа проекта: создаем стратегию с&nbsp;пошаговым планом или готовим график работ.',},
          {subtitle: 'Реализация', text: 'Реализуем проект по&nbsp;утвержденному плану.',},
          {subtitle: 'Отчетность', text: 'Предоставляем отчеты ежемесячно, корректируем вектор стратегии в&nbsp;случае необходимости, держим на&nbsp;контроле ключевые показатели.',},
        ]
      },
      {
        key: 'feature',
        title: 'Особенности работы',
        items: [
          { subtitle: 'Считаем экономику проекта от&nbsp;охватов до&nbsp;продаж', text: 'Нам важно сделать продвижение таким, чтобы оно было выгодно вам и&nbsp;бюджет, потраченный на&nbsp;рекламу, окупался.'},
          { subtitle: 'Мы&nbsp;беремся за&nbsp;проект только после глубокого погружения', text: 'Мы&nbsp;изучаем особенности продукта или услуги и&nbsp;путь клиента по&nbsp;воронке продаж. Нам важно понимать, что запущенный трафик пойдет по&nbsp;верному пути и&nbsp;будет приносить прибыль на&nbsp;длинной дистанции.'},
          { subtitle: 'Любим сложные проекты', text: 'Особенно проекты со&nbsp;сложной воронкой, где цикл сделки может идти несколько месяцев. Строим многоступенчатые ретаргетинговые кампании. Объединяем сразу несколько источников трафика. Любим нешаблонные решения.'},
          { subtitle: 'Соцсети&nbsp;&mdash; наши лучшие друзья', text: 'Работаем со&nbsp;всеми соц.сетями, знаем особенности каждой. Следим за&nbsp;трендами, но&nbsp;приоритетным считаем такую рекламу, которая работает и&nbsp;приносит результат, а&nbsp;не&nbsp;просто красиво выглядит.'},
        ]
      },
      // {
      //   key: 'payment',
      //   title: 'Система оплаты',
      //   paymentInfo,
      // },
      {
        key: 'price',
        title: 'Стоимость работ',
        text: 'Зависит от&nbsp;бюджета проекта. От&nbsp;количества площадок получения трафика. От&nbsp;сложности воронки. Расскажите о&nbsp;вашем проекте, чтобы мы&nbsp;смогли сориентировать вас по&nbsp;цене. Заполните <a href="#services-footer">форму ниже</a>. Это вас ни&nbsp;к&nbsp;чему не&nbsp;обязывает.',
      }
    ]
  },
  {
    menuTitle: 'UX/UI дизайн',
    title: 'UX/UI дизайн',
    url: 'uxui-dizajn',
    icon: 'uiux.svg',
    imgSrc: 'ux-ui-design',
    text: 'Разрабатываем интерфейсы сложных продуктов для веба и&nbsp;мобайла.',
    serviceBlocks: [
      {
        key: 'task',
        title: 'задачи, которые мы решаем',
        text: [
        'Аудит продукта',
        'Создание user-friendly интерфейса',
        'Разработка современного UI',
        ]
      },
      {
        key: 'process',
        title: 'Процесс работы',
        items: [
          {subtitle: 'Брифинг', text: 'Заполняется бриф, мы&nbsp;его изучаем и&nbsp;уточняем нужные детали.',},
          {subtitle: 'Аналитика', text: 'Разбираемся, кто ЦА&nbsp;и&nbsp;пользователи, работаем с&nbsp;фреймворками Persona и&nbsp;CJM, составляем ментальную карту.',},
          {subtitle: 'Прототипирование', text: 'Создаем макет интерфейса &laquo;без дизайна&raquo;, схему блоков. Этот этап позволяет согласовать взаимодействие на&nbsp;начальном этапе проектирования.',},
          {subtitle: 'Дизайн', text: 'Разрабатываем несколько вариантов цветографической концепции. Даем клиенту возможность выбрать наиболее интересный для него вариант.',},
          {subtitle: 'Разработка UI', text: 'Применяем концепцию на&nbsp;прототип. Готовим макеты к&nbsp;передаче на&nbsp;верстку.',},
          {subtitle: 'Авторский надзор', text: 'Проверяем, все&nbsp;ли ок&nbsp;на&nbsp;макете.',},
        ]
      },
      {
        key: 'feature',
        title: 'Особенности работы',
        items: [
          { subtitle: 'Клиент знает свой продукт лучше всех', text: 'Клиент является носителем наибольшего количества инсайтов о&nbsp;продукте, поэтому мы&nbsp;устраиваем совместные сессии и&nbsp;мозговые штурмы с&nbsp;клиентом.'},
        ]
      },
      {
        key: 'payment',
        title: 'Система оплаты',
        paymentInfo,
      },
      {
        key: 'price',
        title: 'Стоимость работ',
        text: 'Зависит от&nbsp;сложности и&nbsp;нагруженности продукта, от&nbsp;сроков.',
      }
    ]
  },
  {
    menuTitle: 'Дизайн - сопровождение',
    title: 'Комплексное сопровождение стартапа. Дизайн.',
    url: 'dizajn-soprovozhdenie',
    icon: 'design.svg',
    imgSrc: 'design',
    text: 'Услуга для тех, кому надо все с&nbsp;ноля.',
    serviceBlocks: [
      {
        key: 'task',
        title: 'задачи, которые мы решаем',
        text: [
        'Анализ рынка',
        'Брендинг',
        'Разработка интерфейса продукта',
        'Создание стиля для социальных сетей',
        ]
      },
      {
        key: 'process',
        title: 'Процесс работы',
        items: [
          {subtitle: 'Брифинг', text: 'Заполняется бриф, мы&nbsp;его изучаем и&nbsp;уточняем нужные детали.',},
          {subtitle: 'Аналитика', text: 'Разбираемся, кто ЦА&nbsp;и&nbsp;пользователи, работаем с&nbsp;фреймворками Persona и&nbsp;CJM, составялем ментальную карту.',},
          {subtitle: 'Дизайн-подход', text: 'Разрабатываем дизайн-подход к&nbsp;проекту. Показываем клиенту концепцию того, как можно представить его продукт в&nbsp;графике.',},
          {subtitle: 'Прототипирование', text: 'Создаем макет интерфейса &laquo;без дизайна&raquo;, схему блоков. Этот этап позволяет согласовать взаимодействие на&nbsp;начальном этапе проектирования.',},
          {subtitle: 'Дизайн логотипа и&nbsp;брендинг', text: 'Разрабатываем несколько вариантов цветографичечской концепции. Даем клиенту возможность выбрать наиболее интересный для него вариант.',},
          {subtitle: 'Разработка UI', text: 'Применяем концепцию на&nbsp;прототип. Готовим макеты к&nbsp;передаче на&nbsp;верстку.',},
          {subtitle: 'Дизайн макетов для соцсетей', text: 'Ретранслируем утвержденную концепцию на&nbsp;социальные сети. Создаем обложки и&nbsp;шаблоны постов.',},
        ]
      },
      {
        key: 'feature',
        title: 'Особенности работы',
        items: [
          { subtitle: 'Не&nbsp;все работы можно вести параллельно', text: 'Например, создать стиль для социальных сетей получится только после брендинга.'},
        ]
      },
      {
        key: 'payment',
        title: 'Система оплаты',
        paymentInfo,
      },
      {
        key: 'price',
        title: 'Стоимость работ',
        text: 'Зависит от&nbsp;сложности и&nbsp;нагруженности продукта, от&nbsp;сроков.',
      },
      {
        key: 'customBlock',
        image: {
          link: 'https://www.behance.net/nekidaem',
          imgSrc: [
            {src: 'behance.avif', type: 'image/afiv'},
            {src: 'behance.webp', type: 'image/webp'},
          ],
          fallbackSrc: 'behance.jpg',
          },
      },
    ]
  },
  {
    menuTitle: 'Хостинг',
    title: 'Вы&nbsp;знаете на&nbsp;каком хостинге находится ваш сервис?',
    url: 'hosting',
    icon: 'frame.svg',
    imgSrc: 'hosting',
    text: `Если на&nbsp;AWS, Hetzner или Digitalocean, то&nbsp;сайт, интернет-магазин может перестать работать в&nbsp;любой момент. Необходим бекап данных и&nbsp;перенос на&nbsp;российский хостинг.<br>
    Мы&nbsp;сделаем это корректно и&nbsp;БЕЗ потери данных!`,
    serviceBlocks: [
      {
        key: 'task',
        title: 'Как происходит переезд:',
        text: [
        'Изучаем проект: анализируем его архитектуру, проводим код-ревью и т.д',
        'Составляем план по&nbsp;переезду: переносим кодовую базу, настраиваем новую архитектуру на&nbsp;российском хостинге, переносим базы данных',
        'Тестируем новый функционал на&nbsp;российском хостинге',
        'Проводим репетицию переезда, чтобы понять сколько времени это займёт',
        'Осуществляем переезд',
        ]
      },
      {
        key: 'feature',
        title: '',
        items: [
          { subtitle: '', text: 'Благодаря репетиции, мы&nbsp;уже имеем понимание о&nbsp;необходимых временных затратах.'},
        ]
      },
      {
        key: 'customBlock',
        text: 'Проверьте хостинг, если есть малейшие сомнения, не&nbsp;рискуйте полной потерей данных!',
      },
    ]
  },
  {
    menuTitle: 'Подбор команды',
    title: 'Подбор команды',
    url: 'podbor-komandy-razrabotchikov-v-proekt-ili-shtat',
    icon: 'search.svg',
    imgSrc: null,
    text: '',
    serviceBlocks: [],
  },
  {
    menuTitle: 'Помощь в&nbsp;переговорах',
    title: 'Помощь в&nbsp;переговорах',
    url: 'pomosh-v-peregovorah',
    icon: 'chat.svg',
    imgSrc: null,
    text: '',
    serviceBlocks: [],
  },
  {
    menuTitle: 'Техническая консультация',
    title: 'Техническая консультация',
    url: 'tehnicheskaya-konsultaciya',
    icon: 'gear.svg',
    imgSrc: null,
    text: '',
    serviceBlocks: [],
  },
  {
    menuTitle: 'Переход с&nbsp;http на&nbsp;https',
    title: 'Переход с&nbsp;http на&nbsp;https',
    url: 'perehod-s-http-na-https',
    icon: 'exit.svg',
    imgSrc: null,
    text: '',
    serviceBlocks: [],
  },
  {
    menuTitle: 'Аудит проекта',
    title: 'Аудит проекта',
    url: 'audit-proekta',
    icon: 'dev.svg',
    imgSrc: null,
    text: '',
    serviceBlocks: [],
  },
  {
    menuTitle: 'Оценка проекта',
    title: 'Оценка проекта',
    url: 'otsenka-proekta',
    icon: 'talk.svg',
    imgSrc: null,
    text: '',
    serviceBlocks: [],
  },
  {
    menuTitle: 'Сопровождение проекта',
    title: 'Сопровождение проекта',
    url: 'soprovozhdenie-proekta',
    icon: 'call.svg',
    imgSrc: null,
    text: '',
    serviceBlocks: [],

  },
  {
    menuTitle: 'Написание ТЗ',
    title: 'Написание ТЗ',
    url: 'sostavlenie-tehnicheskogo-zadaniya',
    icon: 'doc.svg',
    imgSrc: null,
    text: '',
    serviceBlocks: [],
  },
]

/* Данные для aside-блока */

export const sideInfo = [
  { url: "veb-razrabotka", title: 'Технологии:', info: [
    'Сервер: Django, FastAPI, Python, Nginx',
    'DevOps: Gitlab CI/CD, Docker, Portainer',
    'Фоновые задачи: Celery, RabbitMQ',
    'Фронтенд: Vue.js, JavaScript, Webpack',
    'Базы данных: PostgreSQL, Redis, Pgbouncer',
    'Мониторинг: sentry.io, datadog',
    'API Gateway: APISIX',
    'Auth: Keycloak',
    'Tests: Postman, Selenium, schemathesis, pytest',
    'Хостинг: YandexCloud, Selectel, VDS.Selectel, DigitalOcean, Vscale, Hetzner',
    'Real-time: Centrifuge, WebSockets, WebRTC',
    'Моб. разработка: Flutter.dev',
    ],
  },
  { url: 'marketing', title: 'Соц. сети', info: [
    'Вконтакте', 'Tik-Tok', 'Twitter', 'MyTarget', 'Telegram'] },
  { url: 'uxui-dizajn', title: 'Наш стек', info: [
    'Figma', 'Miro', 'Adobe Illustrator', 'Adobe Photoshop', 'Jitter'] },
  { url: 'dizajn-soprovozhdenie', title: 'Наш стек', info: [
    'Figma', 'Miro', 'Adobe Illustrator', 'Adobe Photoshop', 'Jitter'] },
  { url: 'hosting', title: '', info: [], },
  { url: 'podbor-komandy-razrabotchikov-v-proekt-ili-shtat', title: '', info: [], },
  { url: 'pomosh-v-peregovorah', title: '', info: [], },
  { url: 'tehnicheskaya-konsultaciya', title: '', info: [], },
  { url: 'perehod-s-http-na-https', title: '', info: [], },
  { url: 'audit-proekta', title: '', info: [], },
  { url: 'otsenka-proekta', title: '', info: [], },
  { url: 'soprovozhdenie-proekta', title: '', info: [], },
  { url: 'sostavlenie-tehnicheskogo-zadaniya', title: '', info: [], },
]

export const serviceCommonSubtitle = 'На этой странице собраны<br>те услуги, которые мы<br>оказываем клиентам'

export const footerTitle = [
  {
    key: 'default', title: [
    'Хотите заказать услугу?',
    'Оставьте заявку, и мы<br>свяжемся с вами.'
    ],
  },
  {
    key: 'hosting',
    title: [
      'Чтобы узнать подробности<br>и&nbsp;позаботиться о&nbsp;переносе<br>данных на&nbsp;российские<br>сервера&nbsp;&mdash; напишите нам',
    ],
  },
]
